module.exports = __webpack_public_path__ + "img/sixth_san.012cf850.png";